import { GPU } from 'gpu.js';

const gpu_ = new GPU({ mode: 'gpu' }) // change mode to 'cpu' to use cpu

export default {
	data() {
		return {
			gpu: gpu_
		}
	}
}